import React, { ReactElement } from 'react';
import { Tooltip, OverlayTrigger } from 'react-bootstrap';

type AutoSkipTooltipProps = {
  children: React.ReactElement;
  show: boolean;
  onClose: () => void;
}

function AutoSkipTooltip({ children, show, onClose }: AutoSkipTooltipProps): ReactElement {
  return (
    <OverlayTrigger
      placement="bottom-end"
      show={show}
      overlay={(
        <Tooltip id="autoskip-tooltip" className="c-tooltip c-tooltip--auto-skip">
          <div className="c-tooltip__content c-tooltip__content--tutorial">
            <p>
              Toggle-on to order, and start receiving your boxes regularly, on the estimated
              delivery date.
            </p>
            <button
              type="button"
              aria-label="Close"
              data-dismiss="c-tutorial-tooltip"
              className="c-tutorial-tooltip__close"
              onClick={onClose}
            >
              Got it
            </button>
          </div>
        </Tooltip>
      )}
    >
      {children}
    </OverlayTrigger>
  );
}

export default AutoSkipTooltip;
